import React, { useEffect, useRef, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Collapse,
  TextField,
  Button,
  Grid,
  Typography,
  FormControl,
  Select,
  MenuItem,
  Dialog,
  DialogContent,
  DialogActions,
  CircularProgress,
} from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import { makeStyles } from "@material-ui/core/styles";
import Search from "../../grnReceipts/Search";
import PaginationInput from "../../models/pagination/PaginationInput";
import CachedIcon from "@material-ui/icons/Cached";
import moment from "moment";
import clsx from "clsx";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { ChevronRight } from "@material-ui/icons";
import BackDropLoading from "../../models/BackDrop";
import {
  FETCH_ALL_FTE_DETAILS,
  OPEN_BACKDROP,
  UPDATE_FTE_DETAILS,
} from "../../../../containers/actions/types";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAllFETDetails,
  updateFETDetails,
} from "../../../../containers/actions/common/projectActions";
import CustomDialogTitle from "../CustomDialogTitle";
import ViewProjectMonthlyUtilization from "./ViewProjectMonthlyUtilization";

const useStyles = makeStyles((theme) => ({
  refreshContainerSty: {
    display: "flex",
    justifyContent: "flex-end",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "flex-start",
      paddingTop: "1rem",
    },
    [theme.breakpoints.down("xs")]: {
      paddingTop: "1rem",
    },
  },
  refreshSty: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  padR20: {
    paddingRight: 20,
    [theme.breakpoints.down("xs")]: {
      paddingRight: 0,
    },
  },
  hgText: {
    fontWeight: 500,
    paddingRight: theme.spacing(1),
  },
  outlined: {
    padding: theme.spacing(1),
  },
  formControl: {
    minWidth: 120,
    fontSize: "0.875rem",
  },
  formPerPage: {
    minWidth: 60,
    fontSize: "0.875rem",
  },
  table: {
    width: "100%",
    tableLayout: "fixed", // Ensures fixed cell widths
  },
  headerCell: {
    backgroundColor: "#f4f4f4", // Light gray background for the header
    fontWeight: "bold",
    overflowWrap: "break-word",
  },
  cell1: {
    width: "25px",
    maxWidth: "25px",
    minWidth: "26.788px",
    overflowWrap: "break-word",
  },
  cell2: {
    // width: '10%',
    width: "60px",
    maxWidth: "60px",
    minWidth: "62.888px",
    overflowWrap: "break-word",
  },
  cell3: {
    // width: '10%',
    width: "60px",
    maxWidth: "60px",
    minWidth: "62.888px",
    overflowWrap: "break-word",
  },
  cell4: {
    // width: '15%',
    width: "100px",
    maxWidth: "100px",
    minWidth: "104.150px",
    overflowWrap: "break-word",
  },
  cell5: {
    // width: '10%',
    width: "100px",
    maxWidth: "100px",
    minWidth: "104.150px",
    overflowWrap: "break-word",
  },
  cell6: {
    // width: '10%',
    width: "100px",
    maxWidth: "100px",
    minWidth: "87.650px",
    overflowWrap: "break-word",
  },
  cell7: {
    // width: '10%',
    width: "100px",
    maxWidth: "100px",
    minWidth: "90.737px",
    overflowWrap: "break-word",
  },
  cell8: {
    // width: '10%',
    width: "100px",
    maxWidth: "100px",
    minWidth: "87.650px",
    overflowWrap: "break-word",
  },
  cell9: {
    // width: '10%',
    width: "100px",
    maxWidth: "100px",
    minWidth: "90.737px",
    overflowWrap: "break-word",
  },
  cell10: {
    // width: '10%',
    width: "100px",
    maxWidth: "100px",
    minWidth: "104.150px",
    overflowWrap: "break-word",
  },
  cell11: {
    // width: '10%',
    width: "100px",
    maxWidth: "100px",
    minWidth: "104.150px",
    overflowWrap: "break-word",
  },
  actionsCell: {
    // width: '5%',  // Adjust action column width
    width: "100px",
    maxWidth: "100px",
    minWidth: "104.262px",
    overflowWrap: "break-word",
  },
  collapseRow: {
    padding: 0,
  },
  saveButton: {
    backgroundColor: "#f4511e",
    color: "#fff",
    borderRadius: "1rem",
    "&:hover": {
      backgroundColor: "#ff5722",
      color: "#fff",
      borderRadius: "1rem",
    },
  },
  editButton: {
    backgroundColor: "#ff5722",
    color: "#fff",
    borderRadius: "1rem",
    "&:hover": {
      backgroundColor: "#ff5722",
      color: "#fff",
      borderRadius: "1rem",
    },
  },
  combined2Cell: {
    width: "200px",
    maxWidth: "200px",
    minWidth: "200px",
    whiteSpace: "normal",
  },
  textField: {
    "& .MuiOutlinedInput-input": {
      padding: "10px 10px",
    },
  },
  button: {
    borderRadius: "50px", // Rounded corners for pill shape
    border: "1px solid #000", // Border with black color
    padding: "5px 15px", // Padding for buttons
    fontWeight: 500,
    color: "#000", // Text color black
    backgroundColor: "#fff", // Background white
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#f4f4f4", // Slightly darker background on hover
    },
  },
  dialogContent: {
    textAlign: "center",
    padding: "30px 36px 24px 36px",
  },
  avatar: {
    color: "green",
    margin: "0 auto",
    fontSize: "80px",
  },
  dialogActions: {
    justifyContent: "center",
    marginTop: theme.spacing(2),
  },
}));

const FTEBudget = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [error, setError] = useState("");
  const [openRows, setOpenRows] = useState([]);
  const [editRow, setEditRow] = useState(null);
  const [tableData, setTableData] = useState([]);

  const [searchQuery, searchQueryInput] = useState("");
  const [tempSearch, tempSearchQury] = useState("");
  const [noRowsPerPage, setRowsPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [openDialog, setOpenDialog] = useState(false);
  const [loading, setLoading] = useState(true);
  const [updateError, setUpdateErr] = useState(false);
  const [openMonthlyUtilization, setOpenMonthlyUtilization] = useState(false);

  let previousEditRow = useRef();
  let oldFTEData = useRef();

  useEffect(() => {
    setLoading(true);
    setUpdateErr(false);
    dispatch({
      type: UPDATE_FTE_DETAILS,
      payload: undefined,
    });
    dispatch({
      type: FETCH_ALL_FTE_DETAILS,
      payload: undefined,
    });
    dispatch(fetchAllFETDetails());
  }, [dispatch]);

  const rows = useSelector(
    (state) => state.pcmp.common.Projects.fteTableData?.data || []
  );
  const status = useSelector(
    (state) => state.pcmp.common.Projects.fteTableData?.status
  );

  useEffect(() => {
    if (status === true) {
      if (loading) {
        setLoading(false);
      }
      oldFTEData.current = rows;
      setTableData(rows); // Only setting table data here, no need to return rows inside useSelector
    } else if (status === false) {
      if (loading) {
        setLoading(false);
      }
      if (!error) {
        setError("Something went wrong. Please try again later.");
      }
    }
  }, [status, rows, loading, error]);

  const updatedFTEStatus = useSelector((state) => {
    if (state.pcmp.common.Projects.updatedFTE?.status === true) {
      return true;
    } else if (state.pcmp.common.Projects.updatedFTE?.status === false) {
      return false;
    } else {
      return undefined;
    }
  });

  useEffect(() => {
    if (updatedFTEStatus === true) {
      setEditRow(null);
      setOpenDialog(true);
      setUpdateErr(false);
    } else if (updatedFTEStatus === false) {
      setEditRow(null);
      setUpdateErr(true);
    }
  }, [updatedFTEStatus]);

  const handleEdit = (month, year, collabrixFTEID) => {
    setUpdateErr(false);
    if (previousEditRow.current) {
      // const newData = [...tableData];
      // const oldData = [...oldFTEData.current]
      // newData[previousEditRow.current.rowIndex].FTEDetails[previousEditRow.current.dataIndex] = oldData[previousEditRow.current.rowIndex].FTEDetails[previousEditRow.current.dataIndex];
      // const newData =
      // setTableData(newData);
      const oldData = oldFTEData.current
        .filter(
          (row) =>
            row.month === previousEditRow.current.month &&
            row.year === previousEditRow.current.year
        )[0]
        .FTEDetails.filter(
          (detail) =>
            detail.collabrixFTEID === previousEditRow.current.collabrixFTEID
        )[0];
      setTableData((prevTableData) =>
        prevTableData.map((row, i) =>
          row.month === previousEditRow.current.month &&
          row.year === previousEditRow.current.year
            ? {
                ...row,
                FTEDetails: row.FTEDetails.map((detail, j) =>
                  detail.collabrixFTEID ===
                  previousEditRow.current.collabrixFTEID
                    ? { ...oldData }
                    : detail
                ),
              }
            : row
        )
      );
    }
    previousEditRow.current = { month, year, collabrixFTEID };
    setEditRow(collabrixFTEID);
  };

  const handleSave = (item) => {
    setUpdateErr(false);
    setEditRow(null);
    dispatch({
      type: UPDATE_FTE_DETAILS,
      payload: undefined,
    });
    dispatch({
      type: OPEN_BACKDROP,
    });
    let data = {
      fteDetailsList: [{ ...item, cdmoOrgID: 2 }],
    };
    dispatch(updateFETDetails(data));
    //     setTimeout(() => {
    //       dispatch({
    //         type: DESTROY_BACKDROP,
    //       });
    // setEditRow(null);
    // setOpenDialog(true); // Open Dialog when save is clicked
    //      },3000)
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
    dispatch({
      type: UPDATE_FTE_DETAILS,
      payload: undefined,
    });
  };

  const handleChange = (e, month, year, collabrixFTEID, field) => {
    setUpdateErr(false);
    setTableData((prevTableData) =>
      prevTableData.map((row, i) =>
        row.year === year && row.month === month
          ? {
              ...row,
              FTEDetails: row.FTEDetails.map((detail, j) =>
                detail.collabrixFTEID === collabrixFTEID
                  ? { ...detail, [field]: Number(e.target.value) }
                  : detail
              ),
            }
          : row
      )
    );
  };

  const handleSearchQuery = (event) => {
    setUpdateErr(false);
    let { value } = event.target;
    // if (value === '' || value === null) {
    //   tempSearchQury(value);
    //   searchQueryInput('');
    // } else {
    //   tempSearchQury(value);
    // }
  };

  const handleClearSearch = (event) => {
    event.preventDefault();
    tempSearchQury("");
    searchQueryInput("");
    setUpdateErr(false);
  };

  const submitSearch = (event) => {
    event.preventDefault();
    searchQueryInput(tempSearch.trim());
  };

  const handleSetRows = (event) => {
    setRowsPerPage(event.target.value);
    setCurrentPage(1);
    setOpenRows([]);
    setUpdateErr(false);
  };

  const handlePageChange = (page) => {
    setUpdateErr(false);
    setCurrentPage(page);
    setOpenRows([]);
  };

  let totalPages = Math.ceil(tableData.length / noRowsPerPage);

  let records = currentPage * noRowsPerPage;

  const displayRecords = tableData
    ? tableData.slice(records - noRowsPerPage, records)
    : [];

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth() + 1; // getMonth() returns 0-indexed months, so add 1

  const isDateValid = (rowMonth, rowYear) => {
    // const monthNumber = monthMapping[rowMonth.toUpperCase()]; // Convert month string to number
    if (!rowMonth) return false; // Return false if the month is invalid
    if (rowYear > currentYear) {
      return true;
    } else if (rowYear === currentYear) {
      return rowMonth >= currentMonth - 1;
    }
    return false;
  };

  const handleRefresh = () => {
    setError("");
    setLoading(true);
    dispatch({
      type: UPDATE_FTE_DETAILS,
      payload: undefined,
    });
    dispatch({
      type: FETCH_ALL_FTE_DETAILS,
      payload: undefined,
    });
    dispatch(fetchAllFETDetails());
    setEditRow(null);
    setUpdateErr(false);
  };

  return (
    <React.Fragment>
      <BackDropLoading />
      <Grid
        container
        alignItems="center"
        style={{ paddingBottom: "0.5rem", paddingTop: "1rem" }}
      >
        {updateError && (
          <Grid item xs={12} style={{ justifyItems: "center" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "center", // Horizontally center the CircularProgress
                alignItems: "center", // Vertically center the CircularProgress
                height: "50px", // Optional: Set a height to vertically center the loader
                border: "2px solid #FF0000",
                backgroundColor: "#FFF0F0",
                width: "50%",
              }}
            >
              <Typography style={{ textAlign: "center" }}>
                Something went wrong. Please try again.
              </Typography>
            </div>
          </Grid>
        )}
        <Grid item xs={12} sm={10} md={6}>
          <Typography variant="body2" style={{ fontWeight: 500 }}>
            Filter By:
          </Typography>
          <Search
            searchQuery={tempSearch}
            handleSearchQuery={handleSearchQuery}
            handleClearSearch={handleClearSearch}
            submitSearch={submitSearch}
            placeholder={"Search using Compound ID, Account Code"}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Grid container className={classes.refreshContainerSty}>
            <Typography variant="caption" className={clsx(classes.padR20)}>
              {`Last synced @ ${moment(new Date()).format(
                "HH:mm:ss; DD MMMM YYYY"
              )}`}
            </Typography>

            <Typography
              variant="caption"
              color="primary"
              className={classes.refreshSty}
              onClick={handleRefresh}
            >
              Refresh
              <CachedIcon color="primary" style={{ fontSize: 15 }} />
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid container alignItems="center" justifyContent="space-between">
        <Grid
          item
          style={{
            display: "flex",
            gap: "20px",
            marginTop: "20px",
            justifyContent: "center",
          }}
        >
          <Button
            className={classes.button}
            onClick={() => setOpenMonthlyUtilization(true)}
          >
            View Monthly and Cumulative Utilization by Project
          </Button>
          {/* <Button className={classes.button}>View Cumulative Utilization by Project</Button> */}
        </Grid>
        <Grid item>
          <Typography variant="body2" className={classes.hgText}>
            PER PAGE
          </Typography>
          <FormControl className={classes.formPerPage}>
            <Select
              labelId="perpage-filter"
              id="perpage-filter-id"
              value={noRowsPerPage}
              variant="outlined"
              onChange={handleSetRows}
              classes={{
                outlined: classes.outlined,
              }}
            >
              <MenuItem value={3}>3</MenuItem>
              <MenuItem value={5}>5</MenuItem>
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={15}>15</MenuItem>
              <MenuItem value={30}>30</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      <TableContainer component={Paper} style={{ marginTop: 20 }}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell
                className={`${classes.cell1} ${classes.headerCell}`}
              ></TableCell>
              <TableCell
                className={`${classes.cell2} ${classes.headerCell}`}
              ></TableCell>
              <TableCell
                className={`${classes.cell3} ${classes.headerCell}`}
              ></TableCell>
              <TableCell
                className={`${classes.cell4} ${classes.headerCell}`}
              ></TableCell>
              <TableCell
                className={`${classes.cell5} ${classes.headerCell}`}
              ></TableCell>
              <TableCell
                style={{ textAlign: "right", paddingRight: "0px" }}
                className={` ${classes.cell6} ${classes.headerCell}`}
              >
                Process{" "}
              </TableCell>
              <TableCell
                style={{ textAlign: "left", paddingLeft: "3px" }}
                className={`${classes.cell7} ${classes.headerCell}`}
              >
                Development
              </TableCell>
              <TableCell
                style={{ textAlign: "right", paddingRight: "0px" }}
                className={`${classes.cell8} ${classes.headerCell}`}
              >
                Analytical{" "}
              </TableCell>
              <TableCell
                style={{ textAlign: "left", paddingLeft: "3px" }}
                className={`${classes.cell9} ${classes.headerCell}`}
              >
                Development
              </TableCell>
              <TableCell
                className={`${classes.cell10} ${classes.headerCell}`}
              ></TableCell>
              <TableCell
                className={`${classes.cell11} ${classes.headerCell}`}
              ></TableCell>
              <TableCell
                className={`${classes.actionsCell} ${classes.headerCell}`}
              ></TableCell>
            </TableRow>
          </TableHead>

          <TableHead>
            <TableRow>
              <TableCell
                className={`${classes.cell1} ${classes.headerCell}`}
              ></TableCell>
              <TableCell className={`${classes.cell2} ${classes.headerCell}`}>
                Month
              </TableCell>
              <TableCell className={`${classes.cell3} ${classes.headerCell}`}>
                Year
              </TableCell>
              <TableCell className={`${classes.cell4} ${classes.headerCell}`}>
                Compound ID
              </TableCell>
              <TableCell className={`${classes.cell5} ${classes.headerCell}`}>
                Account Code
              </TableCell>
              <TableCell
                align="right"
                className={`${classes.cell6} ${classes.headerCell}`}
              >
                FTE Months
              </TableCell>
              <TableCell
                align="right"
                className={`${classes.cell7} ${classes.headerCell}`}
              >
                Amount
              </TableCell>
              <TableCell
                align="right"
                className={`${classes.cell8} ${classes.headerCell}`}
              >
                FTE Months
              </TableCell>
              <TableCell
                align="right"
                className={`${classes.cell9} ${classes.headerCell}`}
              >
                Amount
              </TableCell>
              <TableCell
                align="right"
                className={`${classes.cell10} ${classes.headerCell}`}
              >
                RM Costs
              </TableCell>
              <TableCell
                align="right"
                className={`${classes.cell11} ${classes.headerCell}`}
              >
                Manufacturing Compensation
              </TableCell>
              <TableCell
                align="center"
                className={`${classes.actionsCell} ${classes.headerCell}`}
              >
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading === true ? (
              <TableRow style={{ height: 150 }}>
                <TableCell colSpan={12}>
                  <div style={{ textAlign: "center" }}>
                    <CircularProgress color="primary" />
                  </div>
                </TableCell>
              </TableRow>
            ) : error !== "" ? (
              <TableRow
                style={{
                  border: "2px solid #FF0000",
                  backgroundColor: "#FFF0F0",
                }}
              >
                <TableCell colSpan={12} align="center">
                  Something went wrong. Please try again later.
                </TableCell>
              </TableRow>
            ) : (
              displayRecords &&
              (displayRecords.length > 0 ? (
                displayRecords
                  .sort((a, b) => {
                    if (a.year === b.year) {
                      return b.month - a.month;
                    }
                    return b.year - a.year;
                  })
                  .map((row, rowIndex) => (
                    <React.Fragment key={rowIndex}>
                      <TableRow>
                        <TableCell
                          className={`${classes.cell1} ${classes.headerCell}`}
                        >
                          <IconButton
                            size="small"
                            onClick={() => {
                              openRows.includes(rowIndex)
                                ? setOpenRows(
                                    openRows.filter((item) => item !== rowIndex)
                                  )
                                : setOpenRows([...openRows, rowIndex]);
                            }}
                          >
                            {openRows.includes(rowIndex) ? (
                              <KeyboardArrowUpIcon />
                            ) : (
                              <KeyboardArrowDownIcon />
                            )}
                          </IconButton>
                        </TableCell>
                        <TableCell
                          className={`${classes.cell2} ${classes.headerCell}`}
                        >
                          {row.monthName}
                        </TableCell>
                        <TableCell
                          className={`${classes.cell3} ${classes.headerCell}`}
                        >
                          {row.year}
                        </TableCell>
                        <TableCell
                          className={`${classes.cell4} ${classes.headerCell}`}
                        ></TableCell>
                        <TableCell
                          className={`${classes.cell5} ${classes.headerCell}`}
                        ></TableCell>
                        <TableCell
                          className={`${classes.cell6} ${classes.headerCell}`}
                        ></TableCell>
                        <TableCell
                          className={`${classes.cell7} ${classes.headerCell}`}
                        ></TableCell>
                        <TableCell
                          className={`${classes.cell8} ${classes.headerCell}`}
                        ></TableCell>
                        <TableCell
                          className={`${classes.cell9} ${classes.headerCell}`}
                        ></TableCell>
                        <TableCell
                          className={`${classes.cell10} ${classes.headerCell}`}
                        ></TableCell>
                        <TableCell
                          className={`${classes.cell11} ${classes.headerCell}`}
                        ></TableCell>
                        <TableCell
                          align="center"
                          className={`${classes.actionsCell} ${classes.headerCell}`}
                        ></TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell className={classes.collapseRow} colSpan={12}>
                          <Collapse
                            in={openRows.includes(rowIndex)}
                            timeout="auto"
                            unmountOnExit
                          >
                            <Table>
                              <TableBody>
                                {row.FTEDetails.sort((a, b) => {
                                  return a.collabrixFTEID - b.collabrixFTEID;
                                }).map((item, dataIndex) => (
                                  <TableRow key={dataIndex}>
                                    <TableCell
                                      className={classes.cell1}
                                    ></TableCell>
                                    <TableCell
                                      className={classes.cell2}
                                    ></TableCell>
                                    <TableCell
                                      className={classes.cell3}
                                    ></TableCell>
                                    <TableCell className={classes.cell4}>
                                      {item.collabrixProjectID}
                                    </TableCell>
                                    <TableCell className={classes.cell5}>
                                      {item.accountCode}
                                    </TableCell>
                                    <TableCell
                                      align="right"
                                      className={classes.cell6}
                                    >
                                      {isDateValid(row.month, row.year) ||
                                      editRow === item.collabrixFTEID ? (
                                        <TextField
                                          variant="outlined"
                                          type="number"
                                          value={item.PDFTEMonths}
                                          className={classes.textField}
                                          onChange={(e) =>
                                            handleChange(
                                              e,
                                              row.month,
                                              row.year,
                                              item.collabrixFTEID,
                                              "PDFTEMonths"
                                            )
                                          }
                                        />
                                      ) : (
                                        item.PDFTEMonths
                                      )}
                                    </TableCell>
                                    <TableCell
                                      align="right"
                                      className={classes.cell7}
                                    >
                                      {isDateValid(row.month, row.year) ||
                                      editRow === item.collabrixFTEID ? (
                                        <TextField
                                          variant="outlined"
                                          value={item.PDAmount}
                                          type="number"
                                          className={classes.textField}
                                          onChange={(e) =>
                                            handleChange(
                                              e,
                                              row.month,
                                              row.year,
                                              item.collabrixFTEID,
                                              "PDAmount"
                                            )
                                          }
                                        />
                                      ) : (
                                        new Intl.NumberFormat().format(
                                          item.PDAmount
                                        )
                                      )}
                                    </TableCell>
                                    <TableCell
                                      align="right"
                                      className={classes.cell8}
                                    >
                                      {isDateValid(row.month, row.year) ||
                                      editRow === item.collabrixFTEID ? (
                                        <TextField
                                          variant="outlined"
                                          value={item.ADFTEMonths}
                                          type="number"
                                          className={classes.textField}
                                          onChange={(e) =>
                                            handleChange(
                                              e,
                                              row.month,
                                              row.year,
                                              item.collabrixFTEID,
                                              "ADFTEMonths"
                                            )
                                          }
                                        />
                                      ) : (
                                        item.ADFTEMonths
                                      )}
                                    </TableCell>
                                    <TableCell
                                      align="right"
                                      className={classes.cell9}
                                    >
                                      {isDateValid(row.month, row.year) ||
                                      editRow === item.collabrixFTEID ? (
                                        <TextField
                                          variant="outlined"
                                          value={item.ADAmount}
                                          type="number"
                                          className={classes.textField}
                                          onChange={(e) =>
                                            handleChange(
                                              e,
                                              row.month,
                                              row.year,
                                              item.collabrixFTEID,
                                              "ADAmount"
                                            )
                                          }
                                        />
                                      ) : (
                                        new Intl.NumberFormat().format(
                                          item.ADAmount
                                        )
                                      )}
                                    </TableCell>
                                    <TableCell
                                      align="right"
                                      className={classes.cell10}
                                    >
                                      {isDateValid(row.month, row.year) ||
                                      editRow === item.collabrixFTEID ? (
                                        <TextField
                                          variant="outlined"
                                          value={item.rmCost}
                                          type="number"
                                          className={classes.textField}
                                          onChange={(e) =>
                                            handleChange(
                                              e,
                                              row.month,
                                              row.year,
                                              item.collabrixFTEID,
                                              "rmCost"
                                            )
                                          }
                                        />
                                      ) : (
                                        new Intl.NumberFormat().format(
                                          item.rmCost
                                        )
                                      )}
                                    </TableCell>
                                    <TableCell
                                      align="right"
                                      className={classes.cell11}
                                    >
                                      {isDateValid(row.month, row.year) ||
                                      editRow === item.collabrixFTEID ? (
                                        <TextField
                                          variant="outlined"
                                          value={item.manufacturingCompensation}
                                          type="number"
                                          className={classes.textField}
                                          onChange={(e) =>
                                            handleChange(
                                              e,
                                              row.month,
                                              row.year,
                                              item.collabrixFTEID,
                                              "manufacturingCompensation"
                                            )
                                          }
                                        />
                                      ) : (
                                        new Intl.NumberFormat().format(
                                          item.manufacturingCompensation
                                        )
                                      )}
                                    </TableCell>
                                    <TableCell
                                      align="center"
                                      className={classes.actionsCell}
                                    >
                                      {editRow === item.collabrixFTEID ||
                                      isDateValid(row.month, row.year) ? (
                                        <Button
                                          onClick={() => handleSave(item)}
                                          className={classes.saveButton}
                                        >
                                          Save
                                        </Button>
                                      ) : (
                                        <Button
                                          onClick={() =>
                                            handleEdit(
                                              row.month,
                                              row.year,
                                              item.collabrixFTEID
                                            )
                                          }
                                          className={classes.editButton}
                                        >
                                          Edit
                                        </Button>
                                      )}
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  ))
              ) : (
                <TableRow>
                  <TableCell colSpan={12} align="center">
                    No Records Found
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <Grid
        container
        alignItems="center"
        justifyContent="center"
        style={{ paddingTop: "1rem" }}
      >
        {/* <Pagination
          page={currentPage}
          name='currentPage'
          onChange={(event, page) => handlePageChange(event, page)}
          count={noPages}
          variant='outlined'
          shape='rounded'
        /> */}
        <PaginationInput
          totalPages={totalPages}
          handlePageChange={handlePageChange}
          page={currentPage}
        />
      </Grid>

      {openDialog && (
        <Dialog
          open={openDialog}
          maxWidth="sm"
          fullWidth
          style={{ borderRadius: "14px" }}
        >
          <DialogContent className={classes.dialogContent}>
            <>
              <CheckCircleIcon className={classes.avatar} />

              <Typography
                style={{
                  marginTop: "10px",
                  fontWeight: "600",
                  color: "black",
                  fontSize: "2rem",
                }}
              >
                Details Saved Successfully
              </Typography>
              <Typography
                style={{
                  marginTop: "10px",
                  color: "black",
                }}
              >
                Details Saved Successfully Click the button below to send the
                saved details to the BMS for approval.
              </Typography>
              <DialogActions className={classes.dialogActions}>
                <Button
                  variant="contained"
                  color="primary"
                  endIcon={<ChevronRight />}
                  style={{
                    borderRadius: "20px",
                    textTransform: "none",
                  }}
                  onClick={handleDialogClose}
                >
                  Send for Approval
                </Button>
              </DialogActions>
            </>
          </DialogContent>
        </Dialog>
      )}
      <Dialog open={openMonthlyUtilization} fullScreen>
        <CustomDialogTitle
          onBackClick={() => setOpenMonthlyUtilization(false)}
          title={`View Monthly and Cumulative Utilization by Project`}
        />
        <DialogContent>
          <ViewProjectMonthlyUtilization />
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

export default FTEBudget;
